import { render } from "./ArticleCard.vue?vue&type=template&id=668cce54&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"

import "./ArticleCard.vue?vue&type=style&index=0&id=668cce54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-668cce54"

export default script